import React, { useContext } from "react";
import { Button, Modal } from "carbon-components-react";
import { Add32, Edit32, TrashCan32 } from "@carbon/icons-react";

import { AmortizationContext } from "../AmortizationProvider";
import { dateToShortForm, dollarsTo2Places } from "../helpers";

const styles = require("./styles.module.scss");

interface Props {
  period: string;
  onAddPayment(period: string): void;
  onEditPayment(paymentId: number): void;
  onClose(): void;
}

const ListPaymentsForPeriodModal = ({ period, onAddPayment, onEditPayment, onClose }: Props) => {
  const { busy, payments, deletePayment } = useContext(AmortizationContext);

  const paymentsForPeriod = payments.filter(p => p.payment_period === period);

  return (
    <Modal
      open
      size="sm"
      modalHeading={`Payments for period starting ${dateToShortForm(period)}`}
      onRequestClose={onClose}
      passiveModal
    >
      <div className={styles.container}>
        <div className={styles.button}>
          <Button size="sm" renderIcon={Add32} disabled={busy} onClick={() => onAddPayment(period)}>
            Add payment
          </Button>
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Check date</th>
              <th>Check amount</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {paymentsForPeriod.map((payment, idx) => {
              const { id, check_date, check_amount } = payment;

              return (
                <tr key={id}>
                  <td>{idx + 1}</td>
                  <td>{dateToShortForm(check_date)}</td>
                  <td>{dollarsTo2Places(check_amount)}</td>
                  <td className={styles.control}>
                    <Button
                      size="sm"
                      kind="ghost"
                      renderIcon={Edit32}
                      disabled={busy}
                      onClick={() => onEditPayment(id)}
                    >
                      Edit
                    </Button>
                  </td>
                  <td className={styles.control}>
                    <Button
                      size="sm"
                      kind="ghost"
                      renderIcon={TrashCan32}
                      disabled={busy}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to delete this payment?")) {
                          if (paymentsForPeriod.length === 1) {
                            onClose(); // nothing left to show in this modal
                          }
                          deletePayment(payment);
                        }
                      }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default ListPaymentsForPeriodModal;
